import { createSelector } from '@reduxjs/toolkit';
import { StoreCategory } from '../../types/store';
import { getStoreDistanceToPosition } from '../../utils/store';
import { storesApi } from '../services/stores';
import { CustomWorkTimeMessageType } from '../../types/custom-work-time';
const selectStoresResult = storesApi.endpoints.getStores.select('');
export const selectAllStores = createSelector(selectStoresResult, storesResult => storesResult?.data ?? []);
const getEnhancedSortedStores = (state, position) => {
    const stores = selectAllStores(state);
    return position
        ? stores
            .map(currentStore => ({
            ...currentStore,
            distanceToPosition: getStoreDistanceToPosition(currentStore, position),
        }))
            .sort((first, second) => first.distanceToPosition - second.distanceToPosition)
        : [...stores].sort((first, second) => {
            if (first.category === StoreCategory.Iqos && second.category !== StoreCategory.Iqos) {
                return -1;
            }
            if (first.category !== StoreCategory.Iqos && second.category === StoreCategory.Iqos) {
                return 1;
            }
            return 0;
        });
};
export const getFilteredStores = createSelector((state) => state, state => {
    const { position } = state.location;
    const { storesFilter } = state.stores;
    const enhancedSortedStores = getEnhancedSortedStores(state, position);
    return enhancedSortedStores.filter(currentStore => currentStore.services.some(service => !storesFilter.services || !storesFilter.services.length || storesFilter.services.includes(service)) &&
        (!storesFilter.categories ||
            !storesFilter.categories.length ||
            storesFilter.categories.includes(currentStore.category)) &&
        (!storesFilter.reseller || (currentStore.reseller && currentStore.reseller.id === storesFilter.reseller)) &&
        (!storesFilter.productVersion ||
            !storesFilter.productVersion.length ||
            currentStore.sellingProductVersions.some(productVersion => storesFilter.productVersion && storesFilter.productVersion.includes(productVersion))));
});
export const getClosestIqosStore = createSelector((state) => state, state => {
    const { position } = state.location;
    return getEnhancedSortedStores(state, position).find(currentStore => currentStore.category.includes(StoreCategory.Iqos));
});
export const getStoreById = () => {
    return createSelector([
        state => selectAllStores(state),
        (state, id) => {
            return id;
        },
    ], (stores, id) => stores.find((store) => store.id === Number(id)));
};
export const lastIqosStoreCustomWorkTime = () => {
    return createSelector([state => state.stores, (state, store) => store], (stores, iqosStore) => [...stores.customWorkTimes]
        .reverse()
        .find(customWorkTime => customWorkTime.messageType === CustomWorkTimeMessageType.IqosStore &&
        customWorkTime.storeLocatorPin?.id === iqosStore.id));
};
